import React, { } from 'react'
import { Dialog, Container, Chip, Button, Box, Typography, Checkbox, ButtonBase, Backdrop } from "@mui/material"
import CMSApi from '../../utils/opsloth_cms_service_api'
import OrderTableArray from "../Orders/OrderTableArray"
import { CheckBox, ChildCareOutlined, Warning } from '@mui/icons-material'
import exportOrdersToExcel from '../../utils/exportOrdersToExcel'
import CircularProgressWithLabel from '../public/CircularProgressWithLabel'
import LogsDialog from '../public/LogsDialog'
import DialogTextfields from '../public/DialogTextfields'

const headers = ['序号', '例图', '品牌', '货号', '日文名称', '中文名称', '日元售价', '代理版(元/个)', '日版(元/个)', '每袋数量', '每箱数量', '订购(袋)', '订购(箱)', '备注', '金额', '发货状态']
const headers_key = ['order', 'mainImage', 'brand', 'product_code', 'name_jp', 'name_zh', 'price_jpy', 'price_cny_cn', 'price_cny_jp', 'pack_spec', 'carton_spec', 'order_number_pack', 'order_number_carton', 'order_remark', 'order_price', 'cargo_sent']

const headers_can_pay_balance = ['序号', '例图', '品牌', '货号', '日文名称', '中文名称', '日元售价', '代理版(元/个)', '日版(元/个)', '每袋数量', '每箱数量', '订购(袋)', '订购(箱)', '备注', '金额', '发货状态', "开启补款", "补款数量"]
const headers_key_can_pay_balance = ['order', 'mainImage', 'brand', 'product_code', 'name_jp', 'name_zh', 'price_jpy', 'price_cny_cn', 'price_cny_jp', 'pack_spec', 'carton_spec', 'order_number_pack', 'order_number_carton', 'order_remark', 'order_price', 'cargo_sent', "can_pay_balance", "can_pay_balance_number"]

const headers_animals_presale = ['序号', '例图', '子分类', '中文名称', '单价(元/只)', '定金比例', '截单时间', '到货时间', '预定数量', '总金额']
const headers_animals_presale_key = ['order', 'mainImage', 'sub_category', 'name_zh', 'price_cny_cn', 'deposit_percentage', 'cut_off_date', 'launch_date', 'order_animal_number', 'order_price']

const headers_animals_presale_can_pay_balance = ['序号', '例图', '子分类', '中文名称', '单价(元/只)', '定金比例', '截单时间', '到货时间', '预定数量', '总金额', "开启补款", "补款数量"]
const headers_animals_presale_key_can_pay_balance = ['order', 'mainImage', 'sub_category', 'name_zh', 'price_cny_cn', 'deposit_percentage', 'cut_off_date', 'launch_date', 'order_animal_number', 'price_cny_cn', "can_pay_balance", "can_pay_balance_number"]

const headers_statistics = ['序号', '例图', '品牌', '货号', '日文名称', '中文名称', '日元售价', '代理版(元/个)', '日版(元/个)', '每袋数量', '每箱数量', '订购(袋)', '订购(箱)', '备注', '金额', '发货状态']
const headers_key_statistics = ['order', 'mainImage', 'brand', 'product_code', 'name_jp', 'name_zh', 'price_jpy', 'price_cny_cn', 'price_cny_jp', 'pack_spec', 'carton_spec', 'order_number_pack', 'order_number_carton', 'order_remark', 'order_price', 'cargo_sent']

const pageSize = 10

type product = {
  order_animal_number: number
  excelOutchecked: boolean,
  product_id: string,
  mainImage: string,
  brand: string,
  product_code: string,
  name_jp: string,
  name_zh: string,
  price_jpy: number,
  price_cny_cn: number,
  price_cny_jp: number,
  pack_spec: number,
  carton_spec: number,
  launch_date: string,
  arrived: string,
  order_number_pack: number,
  order_number_carton: number,
  order_remark: string,
  cargo_sent: string,
  double_checked: string,
  order_id: string
}
type order = {
  products: product[],
  customer_id: string,
  category: string,
  company: string,
  price_cny: number,
  deposit_cny: number,
  balance_cny: number,
  logistic_cny: number,
  cargo_sent: string,
  cargo_no: string,
  order_status: string,
  order_type: string,
  double_checked: string,
  remark: string,
  createdAt: string,
  domin: string,
  out_trade_no: string,
  _id: string
}


function TableListOrdersDialog(props: any) {
  // console.log(props)
  let [orderTableRes, setOrderTableRes] = React.useState<order[]>([])
  let [orderTableResFiltered, setOrderTableResFiltered] = React.useState<order[]>([])
  let [excelOutCount, setExcelOutCount] = React.useState(0)
  let [orderTableResStatistics, setOrderTableResStatistics] = React.useState<object>()
  let [currentPage, setCurrentPage] = React.useState(0)
  let [companys, setCompanys] = React.useState<string[]>([])
  let [companysChosen, setCompanysChosen] = React.useState<string[]>([])
  const [exportPercentage, setExportPercentage] = React.useState(0)

  const [logsDialogOpen, setLogsDialogOpen] = React.useState(false)
  const [documentLogsId, setDocumentLogsId] = React.useState('')

  const handleGetProductOrderedList = async (currentPage?: number) => {
    const ordersRes: any = await getOrdersByProducts(currentPage ?? 0)

    setOrderTableRes([...ordersRes?.data ?? []])
    sortOrdersTable(ordersRes?.data ?? [])
  }

  const getOrdersByProducts = (currentPage: number) => {
    const aggregateDataModel = new CMSApi('orders/aggregate')
    return new Promise(async (resolve, reject) => {
      resolve(await aggregateDataModel.post([
        {
          "$match": {
            "deleted": { "$ne": true },
            "order_type": { "$ne": "尾款" },
            'products.product_id': { $in: props.checkboxSelected }
          }
        }, {
          $project: {
            cargo_sent: false,
            cargo_no: false,
            nickname: false,
            updatedAt: false,
          }
        }
      ])
        // await aggregateDataModel
        //   .setFilter({ deleted: { $ne: true }, 'products.product_id': { $in: props.checkboxSelected } })
        //   // .setOptions({ limit: pageSize, skip: currentPage * pageSize })
        //   .setField("-cargo_sent -cargo_no -nickname -updatedAt -customer_id")
        //   .get()
      )

    })
  }

  const setOrderTableResFilteredFunction = () => { //跨订单导出表格，计算长度
    let excelOutCountTemp = 0
    orderTableResFiltered.forEach(order => {
      order.products.forEach(product => {
        if (product.excelOutchecked) {
          excelOutCountTemp++
        }
      })
    })
    setOrderTableResFiltered(orderTableResFiltered)
    setExcelOutCount(excelOutCountTemp)
  }

  const exportExcelCrossOrder = () => {
    let companyTemp = new Map<string, string>()
    let dominsTemp = new Map<string, string>()
    let outTradeNoTemp = new Map<string, string>()
    const readyToExportExcel: product[] = []
    orderTableResFiltered.forEach(order => {
      readyToExportExcel.push(...order.products.filter(product => {
        if (product.excelOutchecked) {
          companyTemp.set(order.company, "")
          if (order.domin) {
            dominsTemp.set(order.domin, "")
          }
          if (order.out_trade_no) {
            outTradeNoTemp.set(order.out_trade_no, "")
          }
        }
        return product.excelOutchecked
      }))
    })
    if (companyTemp.size == 1) {
      let domin: string = ""
      let out_trade_no: string = ""
      if (dominsTemp.size > 1) {
        domin = "混合网站"
      } else if (dominsTemp.size == 1) {
        domin = dominsTemp.entries().next().value?.[0] ?? "未定义"
      }

      if (outTradeNoTemp.size > 1) {
        out_trade_no = ""
      }else if (outTradeNoTemp.size == 1) {
        out_trade_no = outTradeNoTemp.entries().next().value?.[0] ?? ""
      }
      exportOrdersToExcel(
        ['序号', '例图', '品牌', '货号', '日文名称', '中文名称', '日元售价', '代理版(元/个)', '日版(元/个)', '每袋数量', '每箱数量', '订购(袋)', '订购(箱)', '备注', '发货数量', '金额', '发货状态'],
        ['order', 'mainImage', 'brand', 'product_code', 'name_jp', 'name_zh', 'price_jpy', 'price_cny_cn', 'price_cny_jp', 'pack_spec', 'carton_spec', 'order_number_pack', 'order_number_carton', 'order_remark', 'real_number', 'order_price', 'cargo_sent'],
        readyToExportExcel,
        [],
        props.schema.category.label,
        "合并订单",
        companyTemp.entries().next().value?.[0] ?? '未定义客户',
        domin,
        out_trade_no,
        setExportPercentage
      )
    } else if (companyTemp.size > 1) {
      alert("有超过1个跨订单客户！")
    }
  }

  const sortOrdersTable = (orders: order[]) => {
    let products: product[] = []
    let productsFinal: any[] = []
    let companysTemp: string[] = []
    orders.forEach((order: order, order_index: number) => {
      if (companysTemp.indexOf(order.company) == -1) {
        companysTemp.push(order.company)
      }
      if (order.order_status && order.order_status != "创建订单") {
        order.products.forEach((product: any, product_index: number) => {
          orders[order_index].products[product_index].cargo_sent = (orders[order_index].products[product_index].cargo_sent ?? '') + " " + order.order_status
        })
      }
      let orderTemp: order = JSON.parse(JSON.stringify(order))
      orderTemp.products.forEach(product => {
        product.order_id = order._id
        product.order_remark = order.company + '\n' + new Date(order.createdAt).toLocaleString() + '\n' + (product.order_remark ?? "")
        product.double_checked = (order.order_type ? order.order_type + '\n' : '') + (order.double_checked ?? '/')
      })
      if (order.order_status == "未付款订单") {

      } else {
        products.push(...orderTemp.products)
      }
    })
    setCompanys([...companysTemp])
    setCompanysChosen([...companysTemp])
    products = products.filter(a => props.checkboxSelected.indexOf(a.product_id) >= 0)
    products.sort((a: product, b: product) => a.product_id.localeCompare(b.product_id))

    let lastProductIdTemp = products[0]?.product_id ?? ""
    let lastProductPacks = 0
    let lastProductCartons = 0
    let lastProductAnimalOrderNumbers = 0
    let lastProductUnits = 0
    products.forEach((product, index) => {
      // console.log("product?.cargo_sent", product?.cargo_sent, product?.cargo_sent?.indexOf("已取消") == -1)
      if (product?.cargo_sent?.indexOf("已取消") == -1 || !product['cargo_sent']) {
        if (product.product_id == lastProductIdTemp) {
          productsFinal.push(product)
          lastProductPacks += product.order_number_pack
          lastProductCartons += product.order_number_carton
          lastProductUnits += product.order_number_pack * product.pack_spec + product.order_number_carton * product.carton_spec
          lastProductAnimalOrderNumbers += product.order_animal_number
        } else {
          productsFinal.push({ order_number_pack: lastProductPacks, order_number_carton: lastProductCartons, order_remark: lastProductUnits })
          productsFinal.push(product)
          lastProductPacks = product.order_number_pack
          lastProductCartons = product.order_number_carton
          lastProductUnits = product.order_number_pack * product.pack_spec + product.order_number_carton * product.carton_spec
          lastProductAnimalOrderNumbers = product.order_animal_number
        }
        // }
      }
      if (index == products.length - 1) {
        productsFinal.push({ order_number_pack: lastProductPacks, order_number_carton: lastProductCartons, order_remark: lastProductUnits, order_animal_number: lastProductAnimalOrderNumbers })
      }
      lastProductIdTemp = product.product_id
    })

    // setOrderTableRes([...orders ?? []])
    // console.log(products, productsFinal, props.schema)
    setOrderTableResStatistics({ products: [...productsFinal] })
  }

  const handleCompanyChosenChange = () => {
    let orderTableResFiltered: order[] = []
    orderTableResFiltered = orderTableRes?.filter(item => companysChosen.indexOf(item.company) >= 0)
    setOrderTableResFiltered([...orderTableResFiltered])
  }

  const handlePrePageClick = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPageClick = () => {
    if (orderTableRes.length == pageSize && orderTableRes.length > 0) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handleViewPhoneClick = async (event: any) => {
    const storeUserModel = new CMSApi('store_user_info/phone')
    const store_user: any = await storeUserModel.get({ _id: event.currentTarget.dataset._id })
    await navigator.clipboard.writeText(store_user.data?.account ?? "无电话号码")
    alert((store_user.data?.nickname ?? '') + " " + ((store_user.data?.account ?? "无电话号码") == "无电话号码" ? '无电话号码' : store_user.data?.account + ' 已复制成功') )
  }

  React.useEffect(() => {
    if (props.ordersTableShow) {
      handleGetProductOrderedList()
      setCompanys([])
      setCompanysChosen([])
      setOrderTableResFiltered([])
    } else {
      setCurrentPage(0)
    }
  }, [props.ordersTableShow])

  React.useEffect(() => {
    handleCompanyChosenChange()
  }, [companysChosen])

  React.useEffect(() => {
    handleGetProductOrderedList(currentPage)
  }, [currentPage])

  return (
    <Dialog
      maxWidth='xl'
      open={props.ordersTableShow}
      onClose={() => { props.setOrdersTableShow(false) }}
    >
      <Container
        maxWidth='xl'
        sx={{ my: 2 }}
      >
        <Box
          sx={{ background: "#d32f2f", py: .5, px: 1, fontSize: '1em', color: "white" }}
        >
          统计数据
        </Box>
        <OrderTableArray
          schema={props.schema}
          order={orderTableResStatistics}
          headers={props.schema.category.default == "爬宠-预售" ? headers_animals_presale : headers}
          headers_key={props.schema.category.default == "爬宠-预售" ? headers_animals_presale_key : headers_key}
          checkboxSelected={props.checkboxSelected}
        ></OrderTableArray>
        <Box sx={{ background: '#d9e4ff', mt: 2, p: 2 }}>
          {
            companys.map((item) =>
              <Chip
                size='small'
                key={item}
                sx={{ m: .5, cursor: 'pointer' }}
                label={item}
                color={companysChosen.includes(item) ? 'primary' : 'default'}
                onClick={() => {
                  if (!companysChosen.includes(item)) {
                    companysChosen.push(item)
                  } else {
                    companysChosen.splice(companysChosen.indexOf(item), 1)
                  }
                  setCompanysChosen([...companysChosen])
                }}
              />

            )
          }
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button size="small" variant="outlined" sx={{ mx: 2 }} onClick={() => {
              setCompanysChosen([...companys])
            }}>全选</Button>
            <Button size="small" variant="outlined" onClick={() => {
              setCompanysChosen([])
            }}>清除所有</Button>
          </Box>
        </Box>
      </Container>
      <Box sx={{ px: 3, display: 'flex', position: 'sticky', top: 0, zIndex: 1 }}>
        <Button variant="contained" size="large" sx={{ width: '100%', py: 3, fontSize: '1.1em' }} onClick={exportExcelCrossOrder}>
          跨订单导出所选订单{excelOutCount > 0 ? ' 选中' + excelOutCount + '个' : ''}
        </Button>
      </Box>
      {
        orderTableResFiltered.length >= 1 && orderTableResFiltered.map((order: any, orderIndex: number) =>
          <Container
            maxWidth='xl'
            key={order._id}
            sx={{ my: 2 }}
          >
            <Chip
              label={order.deleted ? '已作废 ' + currentPage * pageSize + orderIndex + 1 : currentPage * pageSize + orderIndex + 1}
              color='error'
              size='small'
              sx={{ mb: -1, ml: -1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label={order.deleted ? '已作废 ' + order.company : order.company}
              color={order.deleted ? 'warning' : (order.order_status === '订单已完成' ? 'success' : 'primary')}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label="查看电话"
              onClick={handleViewPhoneClick}
              data-_id={order.customer_id}
              size='small'
              color='secondary'
              sx={{ mb: -1, ml: 1, userSelect: 'none', opacity: 1 }}
            ></Chip>
            {order.order_type && <Chip
              label={order.order_type}
              color='success'
              size='small'
              sx={{ mb: -1, ml: 1, userSelect: 'text' }}
            />}
            {order.double_checked && <Chip
              label={order.double_checked}
              color={order.double_checked === '未核对' ? 'warning' : 'primary'}
              size='small'
              sx={{ mb: -1, ml: 1, userSelect: 'text' }}
            />}
            <Chip
              label={'订单金额：' + order.price_cny + ' 元'}
              color={order.deleted ? 'warning' : (order.order_status === '订单已完成' ? 'success' : 'primary')}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label={'已付定金：' + order.deposit_cny + ' 元'}
              color={order.deleted ? 'warning' : (order.order_status === '订单已完成' ? 'success' : 'primary')}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label={'已付尾款：' + order.balance_cny + ' 元'}
              color={order.deleted ? 'warning' : (order.order_status === '订单已完成' ? 'success' : 'primary')}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label='查看日志'
              color={'primary'}
              size='small'
              onClick={() => {
                setDocumentLogsId(order._id)
                setLogsDialogOpen(true)
              }}
              sx={{ mb: -1, ml: 1.5, userSelect: 'text', cursor: 'pointer' }}
            ></Chip>
            <Chip
              label={'创建时间：' + new Date(order.createdAt).toLocaleString()}
              color={order.deleted ? 'warning' : (order.order_status === '订单已完成' ? 'success' : 'primary')}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            ></Chip>
            <Chip
              label={order?.domin?.indexOf("store.opsloth.com") >= 0
                ? "STORE.OPSLOTH.COM"
                : (
                  order?.domin?.indexOf("starraykuji.com") >= 0
                    ? "STARRAYKUJI.COM"
                    : (
                      order?.domin?.indexOf("jumbotang.com") >= 0
                        ? "JUMBOTANG.COM"
                        : ""
                    )
                )}
              color={order?.domin?.indexOf("store.opsloth.com") >= 0
                ? "primary"
                : (
                  order?.domin?.indexOf("starraykuji.com") >= 0
                    ? "success"
                    : (
                      order?.domin?.indexOf("jumbotang.com") >= 0
                        ? "warning"
                        : "default"
                    )
                )}
              size='small'
              sx={{ mb: -1, ml: 1.5, userSelect: 'text' }}
            />
            <OrderTableArray
              schema={props.schema}
              order={order}
              headers={headers_can_pay_balance}
              headers_key={headers_key_can_pay_balance}
              checkboxSelected={props.checkboxSelected}
              setOrderTableResFilteredFunction={setOrderTableResFilteredFunction}
            ></OrderTableArray>
          </Container >
        )
      }
      {
        orderTableRes.length === 0 && <div style={{ margin: '2em auto 2em auto' }}>无订单</div>
      }
      {/* {
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Button onClick={handlePrePageClick} sx={{ m: '1em' }}>上一页</Button>
          <Typography sx={{ mx: '2em' }}>{currentPage + 1}</Typography>
          <Button onClick={handleNextPageClick} sx={{ m: '1em' }}>下一页</Button>
        </Box>
      } */}
      <Backdrop
        sx={{ background: '#00000044', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={exportPercentage > 0}
      >
        <Box sx={{ background: '#fff', display: 'flex', borderRadius: '100%' }}>
          <CircularProgressWithLabel value={exportPercentage} />
        </Box>
      </Backdrop>
      <LogsDialog
        _id={documentLogsId}
        open={logsDialogOpen}
        setOpen={setLogsDialogOpen}
      ></LogsDialog>
      {/* <DialogTextfields
        schema={props.schema}
        open={modifyDialogOpen}
        setOpen={setModifyDialogOpen}
        title={`修改${props.schema.TABLE.label}`}
        modifyOrAdd='modify'
        modifyColumn={modifyColumn}
        modifyColumnValue={modifyColumnValue}
        setModifyColumnValue={setModifyColumnValue}
        onSubmit={onModifySubmit}
      ></DialogTextfields> */}
    </Dialog >
  )
}

export default TableListOrdersDialog